export const GoogleMapKey = process.env.VUE_APP_GOOGLE_MAP_KEY;
export const API = process.env.VUE_APP_API;
export const CloudFunctions = process.env.VUE_APP_CLOUD_FUNCTIONS_HTTPS_ENDPOINT;
